import { cn } from "@/lib/cn";

/**
 * Reusable content container that constrains width and applies consistent
 * vertical rhythm. Use one per section in Explore mode.
 */
export const ContentContainer = ({
  children,
  className,
  size = "default",
  padded = true,
}) => {
  return (
    <section
      className={cn(
        "haevn-container",
        padded && "py-16 sm:py-20 lg:py-24",
        size === "narrow" && "max-w-3xl",
        size === "wide" && "max-w-7xl",
        className
      )}
    >
      {children}
    </section>
  );
};

export default ContentContainer;
